'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _resizeObserverPolyfill = require('resize-observer-polyfill');

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Grid = require('../Grid/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCell = require('../Grid/GridCell');

var _GridCell2 = _interopRequireDefault(_GridCell);

var _Handle = require('./Handle');

var _Handle2 = _interopRequireDefault(_Handle);

var _Text = require('../Typography/Text');

var _Text2 = _interopRequireDefault(_Text);

var _DefaultProps = require('./DefaultProps');

var _DefaultProps2 = _interopRequireDefault(_DefaultProps);

require('./Slider.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HIDE_LABELS_THRESHOLD = 150;
var SLIDER_HANDLE_SIZE = 0.01;

var Range = function (_Component) {
  _inherits(Range, _Component);

  function Range(props) {
    _classCallCheck(this, Range);

    var _this = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.trackRef = _react2.default.createRef();
    _this.rangeRef = _react2.default.createRef();


    _this.focusedHandleIndex = 0;

    _this.state = {
      draggedHandleIndex: null,
      isMouseOver: false,
      showLabels: true,
      rangeWidth: '104'
    };

    _this.ensureBoundsInRange();

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);

    _this.observer = new _resizeObserverPolyfill2.default(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      return _this.handleResize(entry.contentRect.width);
    });
    return _this;
  }

  _createClass(Range, [{
    key: 'ensureBoundsInRange',
    value: function ensureBoundsInRange() {
      var _this2 = this;

      var values = this.props.values;


      var valuesInRange = values.map(function (value) {
        return _this2.ensureValueInRange(value);
      });

      if (values.some(function (value) {
        return !valuesInRange.includes(value);
      })) {
        this.onChange(valuesInRange);
      }
    }
  }, {
    key: 'ensureValueInRange',
    value: function ensureValueInRange(value) {
      var _props = this.props,
          min = _props.min,
          max = _props.max,
          step = _props.step;

      var valueInRange = Math.max(min, Math.min(value, max));
      return step * Math.round(valueInRange / step);
    }
  }, {
    key: 'ensureValuesDontCrossover',
    value: function ensureValuesDontCrossover(values) {
      var orderedValues = [].concat(_toConsumableArray(values));

      if (orderedValues[0] > orderedValues[1]) {
        switch (this.focusedHandleIndex) {
          case 0:
            orderedValues[0] = orderedValues[1];
            break;
          case 1:
            orderedValues[1] = orderedValues[0];
            break;
          default:
            throw new Error('Unknown handle ' + this.focusedHandleIndex + ' was in focus: change is not applied');
        }
      }
      return orderedValues;
    }
  }, {
    key: 'getPercentageFromValue',
    value: function getPercentageFromValue(value) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;

      var valueInRange = this.ensureValueInRange(value);
      return (valueInRange - min) / (max - min) * 100;
    }
  }, {
    key: 'getValueFromPosition',
    value: function getValueFromPosition(clientX) {
      var _props3 = this.props,
          max = _props3.max,
          min = _props3.min;

      var _trackRef$current$get = this.trackRef.current.getBoundingClientRect(),
          posMin = _trackRef$current$get.left,
          posMax = _trackRef$current$get.right;

      var value = (clientX - posMin) * (max - min) / (posMax - posMin) + min;

      return this.ensureValueInRange(value);
    }
  }, {
    key: 'getValues',
    value: function getValues(clientX) {
      var _this3 = this;

      var values = this.props.values;


      return values.map(function (value, index) {
        if (index === _this3.focusedHandleIndex) {
          return _this3.getValueFromPosition(clientX);
        }
        return value;
      });
    }
  }, {
    key: 'getClosestHandleIndex',
    value: function getClosestHandleIndex(clientX) {
      var values = this.props.values;

      var xValue = this.getValueFromPosition(clientX);
      var closestDist = void 0;

      return values.reduce(function (closestIndex, currentValue, currentIndex) {
        var currentDist = Math.abs(xValue - currentValue);
        if (closestDist === undefined || currentDist < closestDist) {
          closestDist = currentDist;
          return currentIndex;
        }
        if (currentDist === closestDist && xValue > currentValue) {
          return currentIndex;
        }
        return closestIndex;
      }, 0);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rangeRef.current && this.observer.observe(this.rangeRef.current);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      this.observer.unobserve(this.rangeRef.current);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var clientX = event.clientX;

      this.focusedHandleIndex = this.getClosestHandleIndex(clientX);

      event.preventDefault();

      this.setState({ draggedHandleIndex: this.focusedHandleIndex });

      this.handleMouseMove(event);

      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      var onSlideEnd = this.props.onSlideEnd;
      var clientX = event.clientX;

      var values = this.getValues(clientX);
      var orderedValues = this.ensureValuesDontCrossover(values);

      this.setState({ draggedHandleIndex: null });
      onSlideEnd && onSlideEnd(orderedValues);

      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      var clientX = event.clientX;


      this.onChange(this.getValues(clientX));
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var step = this.props.step;
      var values = this.state.values;


      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          values[this.focusedHandleIndex] = this.ensureValueInRange(values[this.focusedHandleIndex] - step);
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          values[this.focusedHandleIndex] = this.ensureValueInRange(values[this.focusedHandleIndex] + step);
          break;
      }

      this.onChange(values);
    }
  }, {
    key: 'handleResize',
    value: function handleResize(rangeWidth) {
      this.setState({ rangeWidth: rangeWidth });
    }
  }, {
    key: 'onChange',
    value: function onChange(values) {
      this.props.onChange(this.ensureValuesDontCrossover(values));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          disabled = _props4.disabled,
          markerValue = _props4.markerValue,
          maxLabel = _props4.maxLabel,
          minLabel = _props4.minLabel,
          size = _props4.size,
          values = _props4.values,
          valueFormatter = _props4.valueFormatter,
          withTooltip = _props4.withTooltip,
          rest = _objectWithoutProperties(_props4, ['disabled', 'markerValue', 'maxLabel', 'minLabel', 'size', 'values', 'valueFormatter', 'withTooltip']);

      var _state = this.state,
          draggedHandleIndex = _state.draggedHandleIndex,
          isMouseOver = _state.isMouseOver,
          rangeWidth = _state.rangeWidth;

      var showLabels = rangeWidth >= HIDE_LABELS_THRESHOLD;
      var valuesAsPercentage = values.map(function (value) {
        return _this4.getPercentageFromValue(value);
      });
      var classes = (0, _classnames2.default)('ax-slider', 'ax-slider--' + size, 'ax-slider__range', {
        'ax-slider--disabled': disabled
      });

      var sliderFillStyle = { left: valuesAsPercentage[0] + '%', width: valuesAsPercentage[1] - valuesAsPercentage[0] + '%' };

      var markerValueAsPercentage = this.getPercentageFromValue(markerValue);
      var sliderMarkerStyle = { left: markerValueAsPercentage + '%' };

      return _react2.default.createElement(
        _Grid2.default,
        { baseRef: this.rangeRef, horizontalGutters: 'tiny', responsive: false,
          verticalAlign: 'middle', verticalGutters: false, wrap: false },
        showLabels && _react2.default.createElement(
          _GridCell2.default,
          { none: true },
          _react2.default.createElement(
            _Text2.default,
            null,
            minLabel
          )
        ),
        _react2.default.createElement(
          _GridCell2.default,
          { width: showLabels ? 70 : 100 },
          _react2.default.createElement(
            _Base2.default,
            _extends({}, (0, _lodash2.default)(rest, ['onSlideEnd', 'min', 'max', 'step']), {
              className: classes,
              onBlur: this.handleBlur,
              onFocus: disabled ? null : this.handleFocus,
              onMouseLeave: function onMouseLeave() {
                return _this4.setState({ isMouseOver: false });
              },
              onMouseOver: function onMouseOver() {
                return _this4.setState({ isMouseOver: true });
              },
              tabIndex: '0' }),
            _react2.default.createElement(
              'div',
              {
                className: 'ax-slider__track',
                onMouseDown: disabled ? null : this.handleMouseDown,
                ref: this.trackRef },
              _react2.default.createElement('div', {
                className: 'ax-slider__fill',
                style: sliderFillStyle }),
              markerValue !== undefined && _react2.default.createElement('div', {
                className: 'ax-slider__marker',
                style: sliderMarkerStyle }),
              _react2.default.createElement(_Handle2.default, { disabled: disabled, isVisible: draggedHandleIndex === 0 || draggedHandleIndex === null && isMouseOver,
                onMouseDown: this.handleMouseDown,
                size: rangeWidth * SLIDER_HANDLE_SIZE,
                value: values[0],
                valueAsPercentage: valuesAsPercentage[0],
                valueFormatter: valueFormatter,
                withTooltip: withTooltip }),
              _react2.default.createElement(_Handle2.default, { disabled: disabled, isVisible: draggedHandleIndex === 1 || draggedHandleIndex === null && isMouseOver,
                onMouseDown: this.handleMouseDown,
                size: rangeWidth * SLIDER_HANDLE_SIZE,
                value: values[1],
                valueAsPercentage: valuesAsPercentage[1],
                valueFormatter: valueFormatter,
                withTooltip: withTooltip })
            )
          )
        ),
        showLabels && _react2.default.createElement(
          _GridCell2.default,
          { none: true },
          _react2.default.createElement(
            _Text2.default,
            null,
            maxLabel
          )
        )
      );
    }
  }]);

  return Range;
}(_react.Component);

Range.propTypes = {
  /** Disabled control of the slider */
  disabled: _propTypes2.default.bool,
  /** Value of the marker to indicate balanced position */
  markerValue: _propTypes2.default.number,
  /** Maximum number that can be selected */
  max: _propTypes2.default.number.isRequired,
  /** Maximum label */
  maxLabel: _propTypes2.default.string,
  /** Minimum number that can be selected */
  min: _propTypes2.default.number.isRequired,
  /** Minimum label */
  minLabel: _propTypes2.default.string,
  /** Called when the sliders value changes */
  onChange: _propTypes2.default.func.isRequired,
  /** Called when the slider is let go */
  onSlideEnd: _propTypes2.default.func,
  /** Size of the slider */
  size: _propTypes2.default.oneOf(['small', 'medium']),
  /** Configures the increments of the slide */
  step: _propTypes2.default.number,
  /** Value formatter for the tooltip */
  valueFormatter: _propTypes2.default.func,
  /** Values */
  values: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  /** Enables a value indicating tooltip */
  withTooltip: _propTypes2.default.bool
};
Range.defaultProps = _DefaultProps2.default;
exports.default = Range;